import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { BsEnMeasurementsSection, BsEnPreparationSection, BsEnResultsSection } from './Sections';
let BsEnLosAngelesValueWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <BsEnPreparationSection />
      </PageSection>
      <PageSection heading="Measurements">
        <BsEnMeasurementsSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <PageSection heading="Results">
        <BsEnResultsSection />
      </PageSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BsEnLosAngelesValueWorksheet.qestIds = [ids.losAngelesValue.BS_EN_1097_2_Clause_5.rev2020];
BsEnLosAngelesValueWorksheet = withInjectedProps(BsEnLosAngelesValueWorksheet);

export { BsEnLosAngelesValueWorksheet };
export default BsEnLosAngelesValueWorksheet;
